import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, variants = fadeUp, className = "", amount = 0.25, ...rest }) => (
  <motion.div
    className={className}
    variants={variants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount }}
    {...rest}
  >
    {children}
  </motion.div>
);
